import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DspCopyChannel, DspCopyChannelProperty, DspDevice, DspDeviceMatrixmixer } from '../models';

@Injectable()
export abstract class ContextMenuApiService {
	public abstract getDevice$(deviceId: string): Observable<DspDevice>;

	public abstract getCopyChannel(channelId: string): Observable<DspCopyChannel>;

	/**
	 * When available, get matrix mixer for device.
	 */
	public abstract getMatrixMixer$(deviceId: string): Observable<DspDeviceMatrixmixer>;

	/**
	 * Update all target channels with given properties from source.
	 */
	public abstract pasteToChannels(
		source: DspCopyChannel,
		targetIds: string[],
		properties: DspCopyChannelProperty[]
	): Observable<void>;

	/**
	 * Update all target channels with AEC reference channel ID from source.
	 */
	public abstract pasteToAecMonoReferenceChannels(
		selectedMonoReferenceSourceId: string,
		targetIds: string[]
	): Observable<void[]>;

	/**
	 * Update all target channels with AEC reference channel ID from source.
	 */
	public abstract pasteToAecStereoReferenceChannels(
		stereoReference: { selectedLeftReferenceSourceId: string; selectedRightReferenceSourceId: string },
		targetIds: string[]
	): Observable<void[]>;
}
